// extracted by mini-css-extract-plugin
export default {"section":"Contatos_section__Qopyn","titulo":"Contatos_titulo__L8k-m","botao":"Contatos_botao__yXw4v","icone":"Contatos_icone__ZlG7D","icones":"Contatos_icones__BwAGm"};